<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold mb-0">
          تنظیمات تاریخ انقضای بن
        </h5>

        <button
          :disabled="disabled || !isValid"
          type="button"
          @click="submitChanges"
          class="btn btn-success"
        >
          ثبت تغییرات
        </button>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="club-setting">
              <div class="club-setting-content">
                <div class="club-setting-title">
                  تاریخ انقضای بن
                </div>

                <div class="club-setting-description">
                  تعداد روزهایی که بن پس از دریافت معتبر است را وارد کنید.
                </div>
              </div>

              <div class="club-setting-input">
                <input
                  type="number"
                  min="1"
                  step="1"
                  class="form-control"
                  :class="{
                    'is-invalid':
                      customers_club_is_bon_expire_day !== null && !isValid,
                  }"
                  v-model.number="customers_club_is_bon_expire_day"
                  :disabled="disabled"
                  placeholder="مثلاً 90"
                />
                <span class="club-setting-unit">روز</span>
              </div>
            </div>

            <div
              v-if="customers_club_is_bon_expire_day !== null && !isValid"
              class="mt-3 alert alert-danger"
            >
              لطفاً یک عدد صحیح بزرگ‌تر از صفر وارد کنید.
            </div>

            <div v-else class="mt-3 alert alert-success">
              بن‌ها پس از
              <strong>{{ customers_club_is_bon_expire_day }}</strong>
              روز منقضی می‌شوند.
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import BonExpireDay from "@@/core/pages/customerClub/clubSettings/bonExpireDay/BonExpireDayImpl.js";

export default {
  extends: BonExpireDay,
};
</script>
<style scoped>
.club-setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  background: #fff;
}

.club-setting-title {
  font-size: 16px;
  font-weight: 700;
  color: #343a40;
}

.club-setting-description {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.8;
  color: #868e96;
}

.club-setting-input {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.club-setting-input .form-control {
  width: 100px;
  text-align: center;
}

.club-setting-unit {
  font-size: 14px;
  color: #495057;
}
</style>
